import { combineReducers } from "@reduxjs/toolkit";
import type { CarsAvailabilityState } from "../features/availability/store";
import carsAvailabilityReducer from "../features/availability/store/slice";
import { carsPostBookingApi } from "../features/postbooking/store/api";
import type { CarShopState } from "../features/shop/store";
import carsShopReducer from "../features/shop/store/slice";

export interface CarsState {
  cars: {
    carsAvailability: CarsAvailabilityState;
    carsShop: CarShopState;
  };
}

export const carsRootReducer = combineReducers({
  carsAvailability: carsAvailabilityReducer,
  carsShop: carsShopReducer,
});

export const carReducers = {
  cars: carsRootReducer,
  [carsPostBookingApi.reducerPath]: carsPostBookingApi.reducer,
};

export const carMiddlewares = [carsPostBookingApi.middleware];

export { carsPostBookingApi };
